export const  MARKER_SYMBOL = {
    markerFile: {
        type: 'identity',
        default: null,
        property: '_symbol_markerFile'
    },
    markerWidth: {
        type: 'identity',
        default: null,
        property: '_symbol_markerWidth'
    },
    markerHeight: {
        type: 'identity',
        default: null,
        property: '_symbol_markerHeight'
    },
    markerPathWidth: {
        type: 'identity',
        default: 20,
        property: '_symbol_markerPathWidth'
    },
    markerPathHeight: {
        type: 'identity',
        default: 20,
        property: '_symbol_markerPathHeight'
    },
    markerDx: {
        type: 'identity',
        default: null,
        property: '_symbol_markerDx'
    },
    markerDy: {
        type: 'identity',
        default: null,
        property: '_symbol_markerDy'
    },
    //marker type properties
    markerType: {
        type: 'identity',
        default: null,
        property: '_symbol_markerType'
    },
    markerPath: {
        type: 'identity',
        default: null,
        property: '_symbol_markerPath'
    },
    markerFill: {
        type: 'identity',
        default: null,
        property: '_symbol_markerFill'
    },
    markerFillPatternFile: {
        type: 'identity',
        default: null,
        property: '_symbol_markerFillPatternFile'
    },
    markerFillOpacity: {
        type: 'identity',
        default: null,
        property: '_symbol_markerFillOpacity'
    },
    markerLineColor: {
        type: 'identity',
        default: null,
        property: '_symbol_markerLineColor'
    },
    markerLineWidth: {
        type: 'identity',
        default: null,
        property: '_symbol_markerLineWidth'
    },
    markerLineOpacity: {
        type: 'identity',
        default: null,
        property: '_symbol_markerLineOpacity'
    },
    markerLineDasharray: {
        type: 'identity',
        default: null,
        property: '_symbol_markerLineDasharray'
    },
    markerLinePatternFile: {
        type: 'identity',
        default: null,
        property: '_symbol_markerLinePatternFile'
    },
    markerVerticalAlignment: {
        type: 'identity',
        default: 'top',
        property: '_symbol_markerVerticalAlignment'
    },
    markerHorizontalAlignment: {
        type: 'identity',
        default: 'middle',
        property: '_symbol_markerHorizontalAlignment'
    },
    markerOpacity: {
        type: 'identity',
        default: 1,
        property: '_symbol_markerOpacity'
    },
    markerPitchAlignment: {
        type: 'identity',
        default: 'viewport',
        property: '_symbol_markerPitchAlignment'
    },
    markerRotationAlignment: {
        type: 'identity',
        default: 'viewport',
        property: '_symbol_markerRotationAlignment'
    },
    markerRotation: {
        type: 'identity',
        default: 0,
        property: '_symbol_markerRotation'
    },
    markerAllowOverlap: {
        type: 'identity',
        default: 0,
        property: '_symbol_markerAllowOverlap'
    },
    markerIgnorePlacement: {
        type: 'identity',
        default: 0,
        property: '_symbol_markerIgnorePlacement'
    },
    markerTextFit: {
        type: 'identity',
        default: null,
        property: '_symbol_markerTextFit'
    },
    markerSpacing: {
        type: 'identity',
        default: 250,
        property: '_symbol_markerSpacing'
    },
    markerTextFitPadding: {
        type: 'identity',
        default: null,
        property: '_symbol_markerTextFitPadding'
    },
    markerPlacement: {
        type: 'identity',
        default: 'point',
        property: '_symbol_markerPlacement'
    },
};

export const TEXT_SYMBOL = {
    //text properties
    textName: {
        type: 'identity',
        default: null,
        property: '_symbol_textName'
    },
    textFaceName: {
        type: 'identity',
        default: null,
        property: '_symbol_textFaceName'
    },
    // textWeight: {
    //     type: 'identity',
    //     default: null,
    //     property: '_symbol_textWeight'
    // },
    // textStyle: {
    //     type: 'identity',
    //     default: null,
    //     property: '_symbol_textStyle'
    // },
    textWrapWidth: {
        type: 'identity',
        default: null,
        property: '_symbol_textWrapWidth'
    },
    textHorizontalAlignment: {
        type: 'identity',
        default: null,
        property: '_symbol_textHorizontalAlignment'
    },
    textVerticalAlignment: {
        type: 'identity',
        default: null,
        property: '_symbol_textVerticalAlignment'
    },
    textFill: {
        type: 'identity',
        default: null,
        property: '_symbol_textFill'
    },
    textSize: {
        type: 'identity',
        default: null,
        property: '_symbol_textSize'
    },
    textHaloRadius: {
        type: 'identity',
        default: null,
        property: '_symbol_textHaloRadius'
    },
    textHaloFill: {
        type: 'identity',
        default: null,
        property: '_symbol_textHaloFill'
    },
    textHaloOpacity: {
        type: 'identity',
        default: 255,
        property: '_symbol_textHaloOpacity'
    },
    textDx: {
        type: 'identity',
        default: 0,
        property: '_symbol_textDx'
    },
    textDy: {
        type: 'identity',
        default: 0,
        property: '_symbol_textDy'
    },
    textOpacity: {
        type: 'identity',
        default: 1,
        property: '_symbol_textOpacity'
    },
    textPitchAlignment: {
        type: 'identity',
        default: 'viewport',
        property: '_symbol_textPitchAlignment'
    },
    textRotationAlignment: {
        type: 'identity',
        default: 'viewport',
        property: '_symbol_textRotationAlignment'
    },
    textRotation: {
        type: 'identity',
        default: 0,
        property: '_symbol_textRotation'
    },
    textAllowOverlap: {
        type: 'identity',
        default: 0,
        property: '_symbol_textAllowOverlap'
    },
    textIgnorePlacement: {
        type: 'identity',
        default: 0,
        property: '_symbol_textIgnorePlacement'
    },
    textSpacing: {
        type: 'identity',
        default: 250,
        property: '_symbol_textSpacing'
    },
    textPlacement: {
        type: 'identity',
        default: 'point',
        property: '_symbol_textPlacement'
    },
};

export const LINE_SYMBOL = {
    lineWidth: {
        type: 'identity',
        default: 2,
        property: '_symbol_lineWidth'
    },
    lineStrokeWidth: {
        type: 'identity',
        default: 0,
        property: '_symbol_lineStrokeWidth'
    },
    lineColor: {
        type: 'identity',
        default: [1, 1, 1, 1],
        property: '_symbol_lineColor'
    },
    lineStrokeColor: {
        type: 'identity',
        default: [0, 0, 0, 0],
        property: '_symbol_lineStrokeColor'
    },
    lineDx: {
        type: 'identity',
        default: 0,
        property: '_symbol_lineDx'
    },
    lineDy: {
        type: 'identity',
        default: 0,
        property: '_symbol_lineDy'
    },
    linePatternFile: {
        type: 'identity',
        default: null,
        property: '_symbol_linePatternFile'
    },
    linePatternAnimSpeed: {
        type: 'identity',
        default: 0,
        property: '_symbol_linePatternAnimSpeed'
    },
    linePatternGap: {
        type: 'identity',
        default: 0,
        property: '_symbol_linePatternGap'
    },
    lineOpacity: {
        type: 'identity',
        default: 1,
        property: '_symbol_lineOpacity'
    },
    lineJoin: {
        type: 'identity',
        default: null,
        property: '_symbol_lineJoin'
    },
    lineCap: {
        type: 'identity',
        default: null,
        property: '_symbol_lineCap'
    },
    lineDasharray: {
        type: 'identity',
        default: null,
        property: '_symbol_lineDasharray'
    },
    lineDashColor: {
        type: 'identity',
        default: null,
        property: '_symbol_lineDashColor'
    }
};

export const SYMBOL_PREFIX = '_symbol_';

export const LINE_GRADIENT_PROP_KEY = '_line_gradient_property';
